import api from '@/utils/api';
import {
    GET_ALL_VOUCHER,
    CREATE_NEW_VOUCHER,
    UPDATE_SPECIFIC_VOUCHER,
    GET_SPECIFIC_VOUCHER,
    REMOVE_VOUCHER,
    GET_ALL_VOUCHER_WITH_CONCATENATE,
    GET_ALL_VOUCHER_BY_ACTIVE,
    VOUCHER_APPLY_CUSTOMER,
    VOUCHER_CUSTOMER_REMOVE,
    VOUCHER_CUSTOMER_UPDATE,
    VOUCHER_CUSTOMER_GET_USED,
    VOUCHER_CUSTOMER_GET_USED_BY_CUSTOMER
} from './types';
import { NotificationManager } from 'react-notifications';

const showRequestError = err => {
    NotificationManager.error(err.response?.data?.msg || 'Không thể xử lý yêu cầu voucher.');
};

export const getAllVoucher = (filter = {}, concatenate = false) => dispatch => {
    return api.get('/vouchers', { params: filter }).then(res => {
        dispatch({
            type: concatenate ? GET_ALL_VOUCHER_WITH_CONCATENATE : GET_ALL_VOUCHER,
            payload: res.data.data
        });
        return res.data;
    }).catch(err => {
        showRequestError(err);
        return Promise.reject(err);
    });
};

export const getAllVoucherByActive = (filter = {}) => dispatch => {
    return api.get('/vouchers/active', { params: filter }).then(res => {
        dispatch({
            type: GET_ALL_VOUCHER_BY_ACTIVE,
            payload: res.data.data,
            concatenate: Number(filter.page || 1) > 1
        });
        return res.data;
    }).catch(err => {
        showRequestError(err);
        return Promise.reject(err);
    });
};

export const getSpecificVoucher = id => dispatch => {
    return api.get(`/vouchers/${id}`).then(res => {
        dispatch({ type: GET_SPECIFIC_VOUCHER, payload: res.data.data });
        return res.data.data;
    }).catch(err => {
        showRequestError(err);
        return Promise.reject(err);
    });
};

export const createNewVoucher = data => dispatch => {
    return api.post('/vouchers', data).then(res => {
        dispatch({ type: CREATE_NEW_VOUCHER, payload: res.data.data });
        NotificationManager.success(res.data.msg);
        return res.data;
    }).catch(err => {
        showRequestError(err);
        return Promise.reject(err);
    });
};

export const updateSpecificVoucher = (id, data) => dispatch => {
    return api.put(`/vouchers/${id}`, data).then(res => {
        dispatch({ type: UPDATE_SPECIFIC_VOUCHER, payload: res.data.data });
        NotificationManager.success(res.data.msg);
        return res.data;
    }).catch(err => {
        showRequestError(err);
        return Promise.reject(err);
    });
};

export const removeVoucher = ids => dispatch => {
    return api.delete('/vouchers', { data: { ids } }).then(res => {
        dispatch({ type: REMOVE_VOUCHER, payload: ids });
        NotificationManager.success(res.data.msg);
        return res.data.data;
    }).catch(err => {
        showRequestError(err);
        return Promise.reject(err);
    });
};

export const voucherApplyCustomer = data => dispatch => {
    return api.post('/vouchers/customer-usages', data).then(res => {
        dispatch({ type: VOUCHER_APPLY_CUSTOMER, payload: res.data.data });
        NotificationManager.success(res.data.msg);
        return res.data.data;
    }).catch(err => {
        showRequestError(err);
        return Promise.reject(err);
    });
};

export const voucherCustomerUpdate = (id, data) => dispatch => {
    return api.put(`/vouchers/customer-usages/${id}`, data).then(res => {
        dispatch({ type: VOUCHER_CUSTOMER_UPDATE, payload: res.data.data });
        NotificationManager.success(res.data.msg);
        return res.data;
    }).catch(err => {
        showRequestError(err);
        return Promise.reject(err);
    });
};

export const voucherCustomerRemove = ids => dispatch => {
    const normalizedIds = Array.isArray(ids) ? ids : [ids];
    return api.delete('/vouchers/customer-usages', { data: { ids: normalizedIds } }).then(res => {
        dispatch({ type: VOUCHER_CUSTOMER_REMOVE, payload: normalizedIds });
        NotificationManager.success(res.data.msg);
        return res.data;
    }).catch(err => {
        showRequestError(err);
        return Promise.reject(err);
    });
};

export const voucherCustomerGetUsed = id => dispatch => {
    return api.get(`/vouchers/customer-usages/${id}`).then(res => {
        dispatch({ type: VOUCHER_CUSTOMER_GET_USED, payload: res.data.data });
        return res.data.data;
    }).catch(err => {
        showRequestError(err);
        return Promise.reject(err);
    });
};

export const voucherCustomerGetUsedByCustomer = customerId => dispatch => {
    return api.get(`/vouchers/customers/${customerId}/usages`).then(res => {
        dispatch({ type: VOUCHER_CUSTOMER_GET_USED_BY_CUSTOMER, payload: res.data.data });
        return res.data.data;
    }).catch(err => {
        showRequestError(err);
        return Promise.reject(err);
    });
};
